<template>
    <div class="project_banner">
        <swiper ref="swiper" class="pc" :options="options">
            <template v-for="(item, index) in data">
                <swiper-slide :key="index">
                    <div class="cover" :style="`background-image: url(${item});`"></div>
                </swiper-slide>
            </template>
        </swiper>
        <div class="swiper-pagination pc"></div>
        <swiper ref="swiperMobile" class="mobile" :options="mobileOptions">
            <template v-for="(item, index) in mobileData">
                <swiper-slide :key="index">
                    <div class="cover" :style="`background-image: url(${item});`"></div>
                </swiper-slide>
            </template>
        </swiper>
        <div class="swiper-pagination mobile"></div>
    </div>
</template>

<script>
import { swiper, swiperSlide, directive, navigation } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
export default {
    name: "projectBanner",
    props: [ 'data', 'mobileData' ],
    data() {
        return {
            options: {
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                resistanceRatio: 0,
                pagination: {
                    el: '.project_banner .swiper-pagination.pc',
                    clickable: true,
                },
                observer: true,
                observeParents: true,
            },
            mobileOptions: {
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                resistanceRatio: 0,
                pagination: {
                    el: '.project_banner .swiper-pagination.mobile',
                    clickable: true,
                },
                observer: true,
                observeParents: true,
            },
        };
    },
    computed: {
        swiper() {
            return this.$refs.swiper.swiper
        },
        swiperMobile() {
            return this.$refs.swiperMobile.swiper
        },
    },
    components: {
        swiper,
        swiperSlide,
        
    },
    mounted() {
    },
    destroyed() {},
    watch: {
    },
    methods: {},
};
</script>

<style scoped lang="scss">
.project_banner{
    position: relative;
    .mobile{
        display: none;
    }
    .cover{
        width: 100%;
        // height: 6.67rem;
        padding-bottom: 34.7395%;
        background: no-repeat center/cover;
    }
    .swiper-pagination{
        position: absolute;
        bottom: .7rem;
        width: 100%;
        display: flex;
        justify-content: center;
        /deep/ {
            .swiper-pagination-bullet{
                width: 0.6rem;
                height: 0.1rem;
                border-radius: 0;
                background: #a0a0a0;
                margin: 0 .2rem;
                opacity: 1;
                &.swiper-pagination-bullet-active{
                    background: #ff6b23;
                }
            }
        }
    }
    @media only screen and (max-width: 1200px) {
        .pc{
            display: none;
        }
        .mobile{
            display: block;
        }
        .cover{
            height: 21.98rem;
        }
    }
}
</style>